import 'intersection-observer'
import * as React from 'react'
import { InView } from 'react-intersection-observer'
import { IOWidget, Updater, fromJSX } from 'widgets-for-react'
import { blockInviewHandler } from '../../../drupal/rendering/inview_utils.mod'
import { ImageSize } from '../types.gen'
import { getClassName } from '../utils.gen'
import { Media } from '../utils/media.mod'
import { ImageContainer } from './ImageContainer.gen'
import { CMSState } from '../../../publicSite/drupalPage/state'

export type MediaItem = {
  kind_media: 'image' | 'video'
  image?: number
  image_alt?: string
  image_option: string
  size?: ImageSize
  get_default_data_src: () => ImageSize
  get_default_data_srcset: () => [ImageSize, string][]
  video?: { url: string } & {
    id: string
    type: string
    width: string
    height: string
    frameBorder: string
    allowFullScreen: boolean
  }
  caption?: string
  source?: string
  useCookieBar: boolean
  cookiePlaceholder: JSX.Element | string
  cookieButton: string
}

export type MediaBlockProps = {
  index: number
  title?: React.ReactNode
  intro?: string
  items: MediaItem[]
  inview?: {
    threshold?: number
    triggerOnce?: boolean
  }
}

export type MediaBlockStyle = Partial<{
  block_classname: string
  inview_classname: string
  inner_classname: string
  header_classname: string
  title_classname: string
  intro_classname: string
  content_classname: string
  figure_contentwidth_classname: string
  figure_fullwidth_classname: string
  figure_image_classname: string
  figure_video_classname: string
  media_classname: string
  image_classname: string
  placeholder_classname: string
  video_classname: string
  figcaption_classname: string
  caption_classname: string
  source_classname: string
}>

export function MediaBlock(
  props: MediaBlockProps,
  options?: { style?: MediaBlockStyle; key?: string }
): IOWidget<CMSState, Updater<CMSState>> {
  return (cmsState: CMSState) =>
    fromJSX((_) => {
      const mediaItem = (item: MediaItem, index: number) => {
        console.log(item.cookieButton)
        return (
          <figure
            className={`${getClassName(
              options,
              item.image_option == 'content-width' ? 'figure_contentwidth_classname' : 'figure_fullwidth_classname'
            )} ${getClassName(
              options,
              item.kind_media === 'image' ? 'figure_image_classname' : 'figure_video_classname',
              ''
            )} mediablock-gen`}
            key={`media-${options && options.key ? options.key : props.index}-${index}`}
          >
            {item.kind_media === 'image' && item.image != null ? (
              cmsState.images.has(item.image) ? (
                <div className={getClassName(options, 'media_classname', '')}>
                  {ImageContainer(
                    cmsState.images.get(item.image),
                    item.size,
                    getClassName(options, 'image_classname', 'w-100'),
                    item.image_alt,
                    item.get_default_data_src,
                    item.get_default_data_srcset
                  ).run((_) => {})}
                </div>
              ) : (
                <div className={getClassName(options, 'placeholder_classname', '')} aria-hidden="true"></div>
              )
            ) : (
              item.kind_media === 'video' &&
              item.video != undefined && (
                <div className={getClassName(options, 'media_classname', 'text-center')}>
                  <Media kind="media" useCookiebar={item.useCookieBar} url={item.video.url} />
                </div>
              )
            )}

            {(item.caption || item.source) && (
              <figcaption className={getClassName(options, 'figcaption_classname', 'mt-2')}>
                {item.caption && (
                  <p className={getClassName(options, 'caption_classname', 'small text-secondary text-center m-0')}>
                    {item.caption}
                  </p>
                )}
                {item.source && (
                  <p className={getClassName(options, 'source_classname', 'small text-secondary text-center m-0')}>
                    {item.source}
                  </p>
                )}
              </figcaption>
            )}
          </figure>
        )
      }

      return (
        <InView
          as="section"
          onChange={(inView) =>
            blockInviewHandler(
              'media',
              inView,
              `io-${options && options.key ? options.key : props.index}`,
              getClassName(options, 'inview_classname', 'inview')
            )
          }
          triggerOnce={props.inview && props.inview.triggerOnce ? props.inview.triggerOnce : false}
          threshold={props.inview && props.inview.threshold ? props.inview.threshold : 0.1}
          id={`io-${options && options.key ? options.key : props.index}`}
          className={getClassName(options, 'block_classname', '')}
          key={options && options.key ? options.key : `block-${props.index}`}
        >
          <div className={getClassName(options, 'inner_classname', 'py-5')}>
            {(props.title || props.intro) && (
              <header className={getClassName(options, 'header_classname', 'container text-center')}>
                {props.title && <h2 className={getClassName(options, 'title_classname', '3')}>{props.title}</h2>}
                {props.intro && <p className={getClassName(options, 'intro_classname', '')}>{props.intro}</p>}
              </header>
            )}

            {props.items && (
              <div className={getClassName(options, 'content_classname', 'content')}>
                {props.items.map((item: MediaItem, index: number) => mediaItem(item, index))}
              </div>
            )}
          </div>
        </InView>
      )
    })
}
